/**
 * 全局光学背景层（fixed）：
 * - SVG 胶片噪点（feTurbulence，透明度 ~2.8%）消除数码死黑；
 * - 64px 战术网格 + 点阵，解决「过度平面」；
 * - -32° 倾斜体积光束（冷白 + 冰青），mix-blend-mode: screen；
 * - 极淡冷色环境光（冰青 / 绯红 / 靛紫）只做环境光晕，不参与信息表达。
 */
export function AmbientBackdrop() {
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
      <svg
        className="h-full w-full"
        viewBox="0 0 1600 1000"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id="zg-noise">
            <feTurbulence type="fractalNoise" baseFrequency="0.82" numOctaves="3" stitchTiles="stitch" />
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 0.028 0"
            />
          </filter>

          <filter id="zg-beam-blur" x="-25%" y="-25%" width="150%" height="150%">
            <feGaussianBlur stdDeviation="48" />
          </filter>

          <linearGradient id="zg-beam-a" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.1" />
            <stop offset="38%" stopColor="#BAE6FD" stopOpacity="0.035" />
            <stop offset="100%" stopColor="#040507" stopOpacity="0" />
          </linearGradient>

          <linearGradient id="zg-beam-b" x1="0%" y1="0%" x2="82%" y2="100%">
            <stop offset="0%" stopColor="#E2E8F0" stopOpacity="0.055" />
            <stop offset="46%" stopColor="#94A3B8" stopOpacity="0.02" />
            <stop offset="100%" stopColor="#040507" stopOpacity="0" />
          </linearGradient>

          <radialGradient id="zg-ambient-ice" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#7DD3FC" stopOpacity="0.05" />
            <stop offset="100%" stopColor="#040507" stopOpacity="0" />
          </radialGradient>

          <radialGradient id="zg-ambient-rose" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FDA4AF" stopOpacity="0.035" />
            <stop offset="100%" stopColor="#040507" stopOpacity="0" />
          </radialGradient>

          {/* 工程坐标纸由 MatrixBackdrop 的 canvas 绘制；这里只保留光束/噪点。 */}
        </defs>

        <g filter="url(#zg-beam-blur)" style={{ mixBlendMode: 'screen' }}>
          <polygon points="-120,-60 430,-60 1160,960 530,960" fill="url(#zg-beam-a)" />
          <polygon points="360,-60 690,-60 1490,960 1060,960" fill="url(#zg-beam-b)" />
        </g>

        <g style={{ mixBlendMode: 'screen' }}>
          <ellipse cx="180" cy="60" rx="520" ry="360" fill="url(#zg-ambient-ice)" />
          <ellipse cx="1480" cy="40" rx="460" ry="320" fill="url(#zg-ambient-rose)" />
        </g>

        <rect width="1600" height="1000" filter="url(#zg-noise)" opacity="0.9" />
      </svg>

      {/* 底部渐晕，保证长页面底部不「飘」 */}
      <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-[#040507] to-transparent" />
      <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[#040507]/80 to-transparent" />
    </div>
  );
}
